import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-simple-left-wide"} maskId="square-filled-radius-0-stroke-1-IconSidebarSimpleLeftWide"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM8 5V19H21V5H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarSimpleLeftWide;
